import { Theme, css } from '@emotion/react';

const IMAGE_DIAMETER = 120;

export const avatarCardLinkContainer = ({ spacing, breakpoints, colors }: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: ${spacing(2.5)}px ${spacing(5)}px ${spacing(2.5)}px;
  text-align: center;

  ${breakpoints.up('md')} {
    border: 1px solid ${colors.borderDefault};
    padding: 0 ${spacing(5)}px ${spacing(7.75)}px;
  }
`;

export const avatarCardLinkImage = ({ spacing, breakpoints }: Theme) => css`
  height: ${IMAGE_DIAMETER}px;
  width: ${IMAGE_DIAMETER}px;
  border-radius: ${IMAGE_DIAMETER / 2}px;
  overflow: hidden;
  margin-bottom: ${spacing(2.5)}px;

  ${breakpoints.up('md')} {
    margin-top: ${spacing(-2.5)}px;
  }

  & > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const mobileButton = ({ breakpoints }: Theme) => css`
  ${breakpoints.up('md')} {
    display: none;
  }
`;

export const desktopButton = ({ breakpoints }: Theme) => css`
  display: none;
  ${breakpoints.up('md')} {
    display: flex;
  }
`;

export const subtitle = ({ breakpoints, spacing }: Theme) => css`
  margin-bottom: ${spacing(4.5)}px;

  ${breakpoints.up('md')} {
    display: flex;
    margin-bottom: ${spacing(8)}px;
  }
`;
